//
//
//
//
//
//
//
//
//
//
//

export default { name: "MatrixRow" };
